import { type PropsWithChildren } from 'react'

import styles from './styles.module.scss'

export const PresetFooter = ({ children }: PropsWithChildren) => (
  <footer className={styles.footer}>{children}</footer>
)
